import React from 'react';
import PropTypes from 'prop-types';

const ButtonFilled = ({ label, icon: IconComponent, customStyles, palette, size, disabled, onClick }) => {
  const buttonClassName = `button-filled-${size} button-filled-${palette}`;

  return (
    <button className={buttonClassName} style={{ ...customStyles }} disabled={disabled} onClick={onClick}>
      {IconComponent && <IconComponent/>}
      {label && <p className='text'>{label}</p>}
    </button>
  );
};

// ButtonOutline.propTypes = {
//   palette: PropTypes.oneOf(['primary', 'secondary', 'danger', 'success']).isRequired,
//   size: PropTypes.oneOf(['regular', 'small']).isRequired,
// };

export default ButtonFilled;